import React, { useContext } from "react";

// plugin
import { AnimatePresence, motion } from "motion/react";

// style
import "./navProject.scss";

// context
import { LayoutContext } from "../../../../context/layoutContext";

// component

// util
import {
	animationStates,
	blur,
	slideHeight,
	slideWidth,
} from "../../../../util/motionAnimations";

// svg

// component
export default function NavProject() {
	const { projectOpen, navigateProject } = useContext(LayoutContext);

	return (
		<AnimatePresence mode="wait">
			{projectOpen && (
				<motion.div
					key={projectOpen?.frontmatter?.titleShort}
					className="navProjectContainer"
					{...animationStates}
				>
					<motion.div className="topBar" {...slideWidth} />
					<motion.h1 className="navProjectTitle" {...blur}>
						{projectOpen?.frontmatter?.titleShort}
					</motion.h1>
					<motion.button
						className="navProjectClose"
						{...blur}
						onClick={() => navigateProject(null)}
					>
						x
					</motion.button>
					<motion.div className="sideBars" {...slideHeight} />
				</motion.div>
			)}
		</AnimatePresence>
	);
}
